export default {
  SET_documentStatuses(state, value) {
    state.documentStatuses = value;
  },
};
